<template>
  <div class="enrolling-admission-admit-online">
    <PlatDataPanelSelect class="enrolling-admission-admit-online-site"
                         :custom-id="customId"
                         :data-types="['site']"
                         site-group
                         siteLabel="选择教学点">
      <template #default="scope">
        <keep-alive>
          <TemplateDataGrid :key="`${scope.site}`"
                            gridId="EnrollStudentAdmissionGrid"
                            studentType="EMBA"
                            type="online"
                            v-bind="scope"></TemplateDataGrid>
        </keep-alive>
      </template>
    </PlatDataPanelSelect>
  </div>
</template>

<script>
import PlatDataPanelSelect from '../../../wrapper/panel/PlatDataPanelSelect'
import TemplateDataGrid from '../../../../../../templates/TemplateDataGrid'
import routeConfig from '../../../../../../../constants/routeConfig'
export default {
  name: 'EnrollingEMBAAdmissionAdmitOnline',
  components: {
    PlatDataPanelSelect,
    TemplateDataGrid
  },
  data () {
    return {
      customId: ''
    }
  },
  created () {
    this.customId = this.$route.params[routeConfig.DataTile.param]
  }
}
</script>

<style lang="scss">
.enrolling-admission-admit-online {
  height: 100%;
}
</style>
